import { format, isValid, parseISO } from 'date-fns';
import { format as formatTz, toZonedTime } from 'date-fns-tz';
import ms from 'ms';
export var DateFormat;
(function (DateFormat) {
    DateFormat[DateFormat["DATE_SHORT"] = 0] = "DATE_SHORT";
    DateFormat[DateFormat["TIME_SHORT_12H"] = 1] = "TIME_SHORT_12H";
    DateFormat[DateFormat["TIME_LONG_12H"] = 2] = "TIME_LONG_12H";
    DateFormat[DateFormat["TIME_SHORT_24H"] = 3] = "TIME_SHORT_24H";
    DateFormat[DateFormat["TIME_LONG_24H"] = 4] = "TIME_LONG_24H";
    DateFormat[DateFormat["DATE_TIME_12H"] = 5] = "DATE_TIME_12H";
})(DateFormat || (DateFormat = {}));
const dateFormatMap = {
    [DateFormat.DATE_SHORT]: 'MM/dd/yyyy',
    [DateFormat.TIME_SHORT_12H]: 'h:mm a',
    [DateFormat.TIME_LONG_12H]: 'h:mm:ss a',
    [DateFormat.TIME_SHORT_24H]: 'HH:mm',
    [DateFormat.TIME_LONG_24H]: 'HH:mm:ss',
    [DateFormat.DATE_TIME_12H]: 'MM/dd/yyyy h:mm a',
};
const defaultTimezone = 'America/Louisville';
export const formatDate = ({ dateInput, timeZone = defaultTimezone, type = DateFormat.DATE_SHORT, }) => {
    let date;
    if (typeof dateInput === 'string') {
        date = parseISO(dateInput);
    }
    else {
        date = new Date(dateInput);
    }
    if (!isValid(date)) {
        throw new Error('invalid date input');
    }
    const localInput = toZonedTime(date, timeZone);
    return formatTz(localInput, dateFormatMap[type]);
};
export function baseFormatStringAsDate(value, dateFormat) {
    if (!value)
        return '(Empty)';
    if (value instanceof Date && !isValid(value))
        return '(Invalid Date)';
    const formatString = dateFormat ?? 'MM/dd/yyyy';
    try {
        return format(new Date(value), formatString);
    }
    catch {
        // log.warn(error);
    }
    // casting value in order to help Typescript. If value is an
    // instance of Date or number, it will have already returned above.
    const normalizedValue = value.replace('-', '');
    const isCorrectLength = normalizedValue.length === 8;
    const onlyContainsNumbers = /^[0-9]*$/.test(normalizedValue);
    if (isCorrectLength && onlyContainsNumbers) {
        const year = normalizedValue.substring(0, 4);
        const month = normalizedValue.substring(4, 6);
        const day = normalizedValue.substring(6, 8);
        const dateTimeString = `${year}-${month}-${day}`;
        return format(new Date(dateTimeString), formatString);
    }
    return value;
}
// just minimal validation
export const validateDateInRangeOfCurrentDate = (dateStr, { maxDateMsQuery = '0d', minDateMsQuery = '0d', }) => {
    const targetDate = new Date(dateStr);
    const minDate = new Date(new Date().getTime() + ms(minDateMsQuery));
    const maxDate = new Date(new Date().getTime() + ms(maxDateMsQuery));
    if (minDate > maxDate) {
        throw new Error('min date is above max date');
    }
    // Validate the date range
    return targetDate >= minDate && targetDate <= maxDate;
};
export function getDateForFilename(date = new Date()) {
    return format(date, "yyyy-MM-dd-'T'HHmmss");
}
export const getEpochSeconds = (date) => {
    return Math.floor(new Date(date).getTime() / 1000);
};
export const hasTime = (dateString) => dateString.includes('T') || /\d{2}:\d{2}/.test(dateString);
